import { makeAutoObservable } from 'mobx'

class KodaInsightsStore {
	insights = []
	total = 0
	loadStatus = 'idle'
	fetchedOnce = false
	dismissedIds = new Set()

	constructor() {
		makeAutoObservable(this, {}, { autoBind: true })
	}

	beginLoad() {
		this.loadStatus = this.fetchedOnce ? 'refreshing' : 'loading'
	}

	setInsights(items) {
		const next = Array.isArray(items) ? items : []
		const filtered = next.filter(i => i?.id && !this.dismissedIds.has(i.id))
		this.insights = filtered
		this.total = filtered.length
		this.loadStatus = 'success'
		this.fetchedOnce = true
	}

	setError() {
		this.loadStatus = this.insights.length === 0 ? 'error' : 'success'
	}

	dismissById(id) {
		const key = String(id || '').trim()
		if (!key) return
		this.dismissedIds.add(key)
		this.insights = this.insights.filter(i => i.id !== key)
		this.total = this.insights.length
	}

	clearDismissals() {
		this.dismissedIds = new Set()
	}
}

export const kodaInsightsStore = new KodaInsightsStore()
